import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3",
  id: "content_screen"
}
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass('p-3 flex content-main gap-5')
}
const _hoisted_3 = { class: "custom-full" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg px-[32px] max-w-full py-[16px] mb-[50px]" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("iframe", {
            class: "mb-3",
            src: _ctx.businessIframe,
            width: "100%",
            height: "900px"
          }, null, 8, _hoisted_5)
        ])
      ])
    ])
  ]))
}